export default {
  RELEASE_NOTES_CLOSE: 'RELEASE_NOTES_CLOSE',
  RELEASE_NOTES_CLOSE_SUCCESS: 'RELEASE_NOTES_CLOSE_SUCCESS'
}
